/* eslint-disable no-bitwise */

function hasFlag<T extends number>(source: T, candidate: T): boolean {
    return (source & candidate) === candidate;
}

export default hasFlag;
